/* Swym Product Page button */

const swymObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        if (node.classList && node.classList.contains("swym-button-bar")) {
          const productGallery = document.querySelector(
            '.product product-gallery'
          );
          if (productGallery) {
            productGallery.appendChild(node);
            node.classList.add("loaded");
            swymObserver.disconnect();
          }
        }
      }
    });
  });
});

swymObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

/* Swym Product Page button */
